import React, { useState } from "react";
import DemandHeatmap from "./DemandHeatmap";
import ClassDemandTable from "./ClassDemandTable";

const DashboardDetails = ({ capacity, ga4, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className="owner-dashboard__panel owner-dashboard__panel--details">
      <button
        type="button"
        className="owner-dashboard__details-toggle"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
      >
        <span className="owner-dashboard__details-toggle-label">
          {open ? "Hide" : "Show"} detailed schedule data
        </span>
        <span className="owner-dashboard__details-toggle-hint">
          Heatmap &amp; full class list
        </span>
        <span className="owner-dashboard__details-toggle-icon" aria-hidden="true">
          {open ? "−" : "+"}
        </span>
      </button>

      {open && (
        <div className="owner-dashboard__details-body">
          <DemandHeatmap capacity={capacity} />
          <ClassDemandTable
            classDemand={capacity?.classDemand}
            ga4Connected={ga4?.connected}
          />
        </div>
      )}
    </section>
  );
};

export default DashboardDetails;
